<template>
  <div>
    <div class="header">
      <div class="header_left">
        <img class="logo" @click="skipHome" :src="require('@/assets/logo.png')" alt="" />
      </div>
      <div class="header_right">
        <div class="header_top">
          <img class="header_top_icon" :src="require('@/assets/icon/phonenumber.png')" alt="" />
          <div class="header_title"><span>全国统一热线</span></div>
          <div class="header_number"><span>18951524007</span></div>

          <div class="header_top_btn" @click="skipLogin" v-if="!userInfo"><span>登录/注册</span></div>
          <div v-else>
            <el-dropdown v-if="userInfo" @command="handleCommand">
              <span class="el-dropdown-link login">
                {{ userInfo.userName || userInfo.tel }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="freight">
                  <span>我的运单</span></el-dropdown-item>
                <el-dropdown-item  command="logout">
                  <span>退出</span></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="header_list">
          <div class="header_list_item" :class="currentPath == item.path ? 'header_list_item_active' : ''"
            v-for="(item, index) in tabList" :key="index" @click="tabClick(item, index)">
            <img :style="item.style" :src="currentPath == item.path ? item.activeIconPath : item.iconPath"
              alt=""><span>{{ item.label }}</span>
          </div>
        </div>
      </div>
    </div>
    <OrderList ref="orderListRef" />
  </div>
</template>

<script>
import homeIcon from '@/assets/icon/home.png'
import homeActiveIcon from '@/assets/icon/home_a.png'
import orderIcon from '@/assets/icon/order.png'
import orderActiveIcon from '@/assets/icon/order_a.png'
import batchorderIcon from '@/assets/icon/batchorder.png'
import batchorderActiveIcon from '@/assets/icon/batchorder_a.png'
import seriveIcon from '@/assets/icon/servie.png'
import seriveActiveIcon from '@/assets/icon/servie_a.png'
import aboutIcon from '@/assets/icon/abot.png'
import aboutActiveIcon from '@/assets/icon/abot_a.png'
import {
  getAreaSelect,
  getLoginPic,
  getTokenCheck,
  getInfo,
} from "@/api/home";
import { setToken, getToken, removeToken } from "@/utils/auth";
import OrderList from '@/components/OrderList.vue'
export default {
  name: 'Hedaers',
  components:{OrderList},
  data() {
    return {
      tabList: [
        {
          id: 0,
          path: '/',
          iconPath: homeIcon,
          activeIconPath: homeActiveIcon,
          style: { width: '17px', height: '18px' },
          label: '首页'
        },
        {
          id: 1,
          path: '/order',
          iconPath: orderIcon,
          activeIconPath: orderActiveIcon,
          style: { width: '25px', height: '18px' },
          label: '在线下单'
        },
        {
          id: 2,
          path: '/batchOrder',
          iconPath: batchorderIcon,
          activeIconPath: batchorderActiveIcon,
          style: { width: '18px', height: '18px' },
          label: '批量下单'
        },
        {
          id: 3,
          path: '/product',
          iconPath: seriveIcon,
          activeIconPath: seriveActiveIcon,
          style: { width: '19px', height: '18px' },
          label: '服务产品'
        },
        {
          id: 4,
          path: '/about',
          iconPath: aboutIcon,
          activeIconPath: aboutActiveIcon,
          style: { width: '18px', height: '18px' },
          label: '关于我们'
        }
      ],
      userInfo: undefined
    }
  },
  computed: {
    currentPath() {
      return this.$route.path; // 获取当前路由的路径
    },
  },
  created() {
    if (getToken()) {
      this.getInfoData();

    } else {
      localStorage.removeItem("userInfo");
      this.userInfo = null;
    }

  },
  mounted() {
    if (window.localStorage.getItem('userInfo')) {
      this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    }
    // console.log()
    // console.log(this.$router)
  },
  methods: {
    handleCommand(command){
      console.log(command);
      switch(command){
        case 'freight':
          this.openOrderList();
        break;
        case 'logout':
          this.outLogin();
        break;
      }
    },
    // 点击logo返回首页
    skipHome() {
      this.$router.replace({
        path: "/",
      });
    },
    // 点击事件
    tabClick(item, index) {
      this.selectTabIndex = item.path;
      this.$router.push({
        path: item.path
      })
    },
    skipLogin() {
      this.$router.push('/login')
    },
    outLogin() {
      removeToken();
      localStorage.removeItem("userInfo");
      this.$router.replace({
        path: "/",
      });
      window.location.reload();
    },
    getInfoData() {
      getInfo({}).then((response) => {
        // console.log(response);
        if (response.code == 200) {
          this.userInfo = response.user;
          localStorage.setItem(
            "userInfo",
            JSON.stringify(response.user)
          );
        }
      });
    },
    openOrderList(){
      this.$refs.orderListRef.open();
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  width: 1291px;
  margin: 0 auto;
  display: flex;

  .header_left {
    margin-right: 106px;
    padding-top: 21px;

    .logo {
      width: 300px;
      height: 126px;
    }
  }

  .header_right {
    flex: 1;

    .header_top {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-top: 26px;
      margin-bottom: 45px;

      .header_top_icon {
        width: 20px;
        height: 20px;
        margin-right: 8px;
        margin-top: 3px;
      }

      .header_title {
        color: #2F333C;
        font-size: 14px;
        font-family: PingFangSC;
        margin-right: 5px;
        padding-top: 3px;
      }

      .header_number {
        font-size: 22px;
        color: #FF8A00;
        font-weight: bold;
        margin-right: 30px;
        font-family: DINAlternate;
      }

      .header_top_btn {
        width: 126px;
        height: 40px;
        line-height: 40px;
        background: #FF8A00;
        text-align: center;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        user-select: none;
        cursor: pointer;
      }
    }

    .header_list {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .header_list_item {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        font-family: PingFangSC;
        display: flex;
        align-items: center;
        position: relative;
        user-select: none;
        cursor: pointer;

        img {
          margin-right: 10px;
        }

      }

      .header_list_item_active {
        color: #FF8A00;
        position: relative;

        ::before {
          content: '';
          position: absolute;
          left: 0px;
          bottom: -16px;
          width: 100%;
          height: 4px;
          background: #FF8A00;
        }
      }
    }
  }
}

.login {
  font-size: 22px;
  color: #FF8A00;
  font-weight: bold;
  font-family: DINAlternate;
  cursor: pointer;
}
</style>